import type { Claim, ClaimInjuredParty } from '../../../../models/claim'

/** Step 4 (Others Involved) form state — the single source of truth (react-hook-form). */
export interface Step4FormValues {
  // Passengers + injuries
  numPassengers: string
  anyInjuries: boolean | null
  injuredParties: ClaimInjuredParty[]
  numInjured: string
  transportedToHospital: boolean | null
  // Other vehicles
  otherVehiclesInvolved: boolean | null
  otherLicensePlate: string
  otherDriverName: string
  otherInsuranceCompany: string
  otherPolicyNumber: string
  otherContactInfo: string
  // Police & citation
  policeContacted: boolean | null
  policeResponded: boolean | null
  reportFiled: boolean | null
  reportCaseNumber: string
  jurisdiction: string
  citationIssued: string
}

export const STEP4_DEFAULTS: Step4FormValues = {
  numPassengers: '0',
  anyInjuries: null,
  injuredParties: [],
  numInjured: '',
  transportedToHospital: null,
  otherVehiclesInvolved: null,
  otherLicensePlate: '',
  otherDriverName: '',
  otherInsuranceCompany: '',
  otherPolicyNumber: '',
  otherContactInfo: '',
  policeContacted: null,
  policeResponded: null,
  reportFiled: null,
  reportCaseNumber: '',
  jurisdiction: '',
  citationIssued: '',
}

export function claimToStep4Defaults(claim: Claim): Step4FormValues {
  const inj = claim.injuries
  const pol = claim.police
  const ov = claim.otherVehicle
  return {
    numPassengers: inj?.numPassengers != null ? String(inj.numPassengers) : '0',
    anyInjuries: inj?.anyInjuries ?? null,
    injuredParties: inj?.injuredParties ?? [],
    numInjured: inj?.numInjured != null ? String(inj.numInjured) : '',
    transportedToHospital: inj?.transportedToHospital ?? null,
    otherVehiclesInvolved: claim.otherVehiclesInvolved,
    // Prefill the other vehicle's plate from the Step 1 photo capture when unset.
    otherLicensePlate: ov?.licensePlate ?? claim.incident?.otherPartyPlate ?? '',
    otherDriverName: ov?.otherDriverName ?? '',
    otherInsuranceCompany: ov?.insuranceCompany ?? '',
    otherPolicyNumber: ov?.policyNumber ?? '',
    otherContactInfo: ov?.contactInfo ?? '',
    policeContacted: pol?.policeContacted ?? null,
    policeResponded: pol?.policeResponded ?? null,
    reportFiled: pol?.reportFiled ?? null,
    reportCaseNumber: pol?.reportCaseNumber ?? '',
    jurisdiction: pol?.jurisdiction ?? '',
    citationIssued: pol?.citationIssued ?? '',
  }
}

/** Fields that describe one vehicle or report, so an upload read fills them together or not at all. */
export const STEP4_GROUPS: (keyof Step4FormValues)[][] = [
  [
    'otherVehiclesInvolved',
    'otherLicensePlate',
    'otherDriverName',
    'otherInsuranceCompany',
    'otherPolicyNumber',
    'otherContactInfo',
  ],
  ['policeContacted', 'policeResponded', 'reportFiled', 'reportCaseNumber', 'jurisdiction', 'citationIssued'],
  ['anyInjuries', 'injuredParties', 'numInjured', 'transportedToHospital'],
]
